module.exports = __webpack_public_path__ + "public/Icons/11Managecategory.svg?771610bd";